import { render } from "./DashboardHome.vue?vue&type=template&id=a2a3c0e8&scoped=true"
import script from "./DashboardHome.vue?vue&type=script&lang=js"
export * from "./DashboardHome.vue?vue&type=script&lang=js"

import "./DashboardHome.vue?vue&type=style&index=0&id=a2a3c0e8&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a3c0e8"]])

export default __exports__